import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { IVerifyCodeRequestDto, postVerifyCode } from '@/shared/api/auth';
import { getRoutePath } from '@/shared/utils/routes';

export const useVerifyCode = () => {
  const navigate = useNavigate();

  const verifyCodeMutation = useMutation({
    mutationFn: (vars: IVerifyCodeRequestDto) => postVerifyCode(vars),
    onSuccess: () => {
      navigate(getRoutePath('MAIN', 'INDEX'));
    },
  });

  const verifyCode = async (options: IVerifyCodeRequestDto) => {
    return verifyCodeMutation.mutateAsync(options);
  };

  return { verifyCode, isPending: verifyCodeMutation.isPending };
};
